import { useStampStore } from '@/store/stamp';
import { to } from '@tencent/wphk-base-utils';
import { showErrorDialog } from '@tencent/wphk-act-base-ui';
import { elk } from '@tencent/ppd-base-libs';
// import { hideLoading, showErrorDialog, showLoading } from '@tencent/wphk-act-base-ui';

export function useGlobalData() {
  const stampStore = useStampStore(); // store

  // 刷新数据
  const refresh = async () => {
    await Promise.all([
      stampStore.qryUserQual(),
      stampStore.exchActPrizeInfoForGlobal(),
      stampStore.exchActPrizeInfoForNGO(),
      stampStore.getPastData(),
    ]);
  };

  // 初始化数据
  const refreshData = async () => {
    try {
      // 刷新数据
      const globalData = useGlobalData();
      const [refreshErr] = await to(globalData.refresh());
      if (refreshErr) throw refreshErr;
    } catch (error) {
      if ((error as Error).message ===  'Network Error') {
        // 添加上报
        elk({
          key: 'custom',
          str1: 'refreshData',
          str2: 'Network Error',
        });
        return;
      }
      showErrorDialog(error as Error);
    }
  };

  return {
    // 全局刷新数据
    refresh,
    refreshData,
  };
}
